import * as React from "react";
import { IIDCReading } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import {
  IStackTokens,
  Stack,
  Text,
  DefaultButton,
  PrimaryButton,
  Toggle,
} from "office-ui-fabric-react";
import { getAlertDetails } from "../../../services/ThresholdService";
import CustomDrawer from "../../common/CustomDrawer";
import { Formik } from "formik";
import { updateIdcReading } from "../../../services/infrastructure/IdcTemperatureService";
import * as yup from "yup";
import { CustomTextField } from "../../common/Library";

const idcSchema = yup.object().shape({
  name: yup.string(),
  temp: yup.number().required("Required"),
  rh: yup.number().required(),
});
const idcReadingSchema = yup.object().shape({
  readings: yup.array().of(idcSchema),
  remarks: yup.string(),
  recordedBy: yup.string().required(),
});

export interface ManageIdcTemperatureProps {
  data?: IIDCReading;
  closeManageDialog: any;
  handleLoading: any;
  threshold: any;
}

const ManageIdcTemperatureDialog: React.FC<ManageIdcTemperatureProps> = ({
  data,
  handleLoading,
  closeManageDialog,
  threshold,
}) => {
  //state
  const [state, setState] = React.useState({
    idcReading: {
      ...data,
    },
    isLoading: false,
  } as {
    idcReading: IIDCReading;
    isLoading: boolean;
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 8 };
  const closeAddDialog = (data?: IIDCReading) => {
    closeManageDialog(data);
  };
  const onBlurFunc = (value: any, path: string) => {
    if (path.includes("].")) {
      path = path.split("].")[1];
    }
    // console.log("onBlurFunc");
    const { showAlert, msg } = getAlertDetails(path, threshold, value);
    // console.log("[showAlert]", showAlert, msg);
    if (showAlert === true) {
      showConfirmDialog("Alert", msg as string, () => {}, "Ok", true);
    }
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title={"Update IDC Temperature Reading"}
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.idcReading}
            // validationSchema={idcReadingSchema}
            onSubmit={async (values: IIDCReading, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              handleLoading();
              result = await updateIdcReading(obj);
              handleLoading();
              if (result?.success) {
                closeAddDialog(obj);
                showToast(
                  `IDC Temperature Reading updated successfully`,
                  "success"
                );
              } else {
                showToast(
                  `Error while updating an idc temperature reading`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item className="custom-toggle">
                    <Toggle
                      checked={values.isSystemOn}
                      label="System"
                      onText="On"
                      offText="Off"
                      onChange={(e, v) => {
                        setFieldValue("isSystemOn", v);
                      }}
                    />
                  </Stack.Item>
                  {values.readings.map((item, index) => (
                    <Stack.Item key={index}>
                      {/* <br /> */}
                      <Text variant="medium">IDC-{index + 1}</Text>
                      <Stack
                        horizontal
                        wrap
                        tokens={wrapStackTokens}
                        className="pt-24"
                      >
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={`readings[${index}].temp`}
                            label={"Temperature"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                          />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                          <CustomTextField
                            name={`readings[${index}].rh`}
                            label={"RH %"}
                            onBlurFunc={onBlurFunc}
                            type="number"
                          />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  ))}

                  <Stack.Item>
                    <CustomTextField name={`remarks`} label={"Remarks"} />
                  </Stack.Item>
                  <Stack.Item>
                    <CustomTextField
                      name={`recordedBy`}
                      label={"Shift Tech Sign"}
                      disabled
                    />
                  </Stack.Item>
                  <br />
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text="Update" />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageIdcTemperatureDialog;
